import { Component, OnInit, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { Additive } from '../../../../models/Additive.model';
import { HonorariumType } from '../../../../shared/enums/HonorariumType';
import { ConsultantService } from '../../../../services/consultant.service';
import { Consultant } from '../../../../models/Consultant.model';
import { ErrorHandlerProvider } from '../../../../shared/providers/errorHandler.provider';
import { CommonHelper } from "../../../../shared/helpers/CommonHelper";
import { GUARDS } from '../../../../shared/auth/Roles';
import * as moment from 'moment'
@Component({
    selector: 'modal-additive',
    templateUrl: './modalAdditive.component.html',
    styleUrls: ['./modalAdditive.component.css']
})
export class ModalAdditiveComponent implements OnInit {
    @Input() additiveType: number;
    @Input() blockAdditive: any;
    @Input() requesterRole: string;
    @Input() cnaes: any;
    @Output() sendAdditiveData: EventEmitter<any> = new EventEmitter();
    @Output() closeModalAdditive: EventEmitter<boolean> = new EventEmitter();
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    cnpjMask = [/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/];
    additive: Additive = new Additive();
    validDateAdditive: boolean = false;
    showHourValue: boolean = false;
    showTotalValue: boolean = false;
    showHourValueBenefits: boolean = false;
    showMensalHours: boolean = false;
    showSoldHoursValue: boolean = false;
    disableHourValue: boolean = false;
    additiveTypeText: string = '';
    commonHelper: CommonHelper = new CommonHelper();
    GUARDS = GUARDS;

    constructor(
        private consultantService: ConsultantService,
        private toast: ToastsManager,
        private errorHandler: ErrorHandlerProvider,
    ) {}

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.transcriptAdditiveType();
    }

    verifyDate(date, field){
        if(!this.additive.date || !(new RegExp(this.datePattern).test(date))){
            this.toast.warning(`Digite uma data válida.`,"Data inválida!");
            this.additive[`${field}`] = "";
            this.validDateAdditive = false;
        } else {
            this.validDateAdditive = true;
        }
    }

    changedHonorarium() {
        this.showSoldHoursValue = false;
        this.additive.totalValue = 0;

        if (this.additive.honorarium === HonorariumType.HoraAberta) {
            this.showTotalValue = false;
            this.showHourValue = true;
            this.showMensalHours = false;
            this.disableHourValue = false;
        }

        if (this.additive.honorarium === HonorariumType.HoraFechada) {
            this.additive.mensalHours = 168;
            this.showTotalValue = true;
            this.showHourValue = true;
            this.disableHourValue = true;
            this.showMensalHours = true;
            this.calculateHourValue();
        }

        if(this.requesterRole == GUARDS.GOVERNANCE) {
            this.showSoldHoursValue = true;
        }
    }

    calculateHourValue() {
        if (this.additive.honorarium === HonorariumType.HoraFechada) {
            let consultant = new Consultant();
            consultant.contract.mensalHours = this.additive.mensalHours;
            consultant.contract.totalValue = this.additive.totalValue;
            this.additive.hourValue = this.consultantService.calculateHourValue(consultant);
            this.disableHourValue = true;
        } else {
            this.disableHourValue = false;
        }
    }

    async cnpjSearch(){
        try {
            let cnpj = this.additive.oldCnpj
            if(cnpj == '')
                return this.toast.warning('CNPJ não pode ser vazio!');
            if(!this.consultantService.cnpjValid(cnpj))
                return this.toast.warning('CNPJ inválido. CNPJ deve ter 14 caracteres!');

            this.toast.warning('Realizando consulta ao CNPJ...');
            cnpj = cnpj.trim();

            let response = await this.consultantService.getCnpj(cnpj, true);
            if(response.success) {
                if(response.isMei) {
                    this.additive.oldCnpj = '';
                    this.additive.oldCompanyName = '';
                    return this.toast.warning(`O CNPJ ${cnpj} é do tipo MEI e não pode ser utilizado no sistema`, 'CNPJ Bloqueado');
                }

                this.additive.oldCompanyName = response.nome;
                this.additive.oldCompanyAddress = response.logradouro;
                this.additive.oldCompanyNumber = response.numero;
                this.additive.oldCompanyCep = response.cep;
                this.additive.oldCompanyDistrict = response.bairro;
                this.additive.oldCompanyCity = response.municipio;
                this.additive.oldCompanyState = response.uf;
            } else {
                return this.errorHandler.interceptError(response, 'Consultor');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Empresa');
        }
    }

    transcriptAdditiveType() {
        const additiveTypesModel = {
            '1': 'Reajuste de valor',
            '2': 'Renovação de contrato',
            '3': 'Alteração de CNPJ/Razão Social'
        }
        this.additiveTypeText = this.additiveType ? additiveTypesModel[`${this.additiveType}`] : '';
    }

    checkAdditiveValid(): boolean {
        if(this.additiveType == 1 &&
            (Number(this.additive.honorarium) == 0 ||
            (this.additive.honorarium == 1 && !this.additive.hourValue) ||
            (this.additive.honorarium == 2 && (!this.additive.totalValue || !this.additive.mensalHours))
        ))
            return false;
        else if(this.additiveType == 3 && (
            !this.additive.oldCnpj || !this.additive.oldCompanyName ||
            !this.additive.oldCompanyAddress || !this.additive.oldCompanyNumber ||
            !this.additive.oldCompanyCep || !this.additive.oldCompanyDistrict ||
            !this.additive.oldCompanyCity || !this.additive.oldCompanyState ||
            Number(this.additive.oldCompanyState) == 0
        ))
            return false;

        return true;
    }

    clear() {
        this.additive = new Additive();
        this.additive.date = '';
    }

    cancelAdditive() {
        this.clear();
        this.closeModalAdditive.emit(true);
    }

    saveAdditive() {
        this.verifyDate(this.additive.date,'date');
        if(!this.validDateAdditive) return;
        this.additive.additiveType = this.additiveType;
        this.additive.pendingApproval = true;
        this.additive.createdAt = moment(new Date()).format("DD/MM/YYYY")
        this.sendAdditiveData.emit(this.additive);
    }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/components/modalAdditive/modalAdditive.component.ts